import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

var afterScrollFolder = function afterScrollFolder(oldPartialTree, currentFolderId, items, nextPagePath, validateSingleFile) {
  var currentFolder = oldPartialTree.find(function (i) {
    return i.id === currentFolderId;
  });
  var newFolders = items.filter(function (i) {
    return i.isFolder === true;
  });
  var newFiles = items.filter(function (i) {
    return i.isFolder === false;
  }); // just doing `scrolledFolder.nextPagePath = ...` in a non-mutating way

  var scrolledFolder = _objectSpread({}, currentFolder, {
    nextPagePath: nextPagePath
  });

  var partialTreeWithUpdatedScrolledFolder = oldPartialTree.map(function (folder) {
    return folder.id === scrolledFolder.id ? scrolledFolder : folder;
  });
  var isParentFolderChecked = scrolledFolder.type === 'folder' && scrolledFolder.status === 'checked';
  var folders = newFolders.map(function (folder) {
    return {
      type: 'folder',
      id: folder.requestPath,
      cached: false,
      nextPagePath: null,
      status: isParentFolderChecked ? 'checked' : 'unchecked',
      parentId: scrolledFolder.id,
      data: folder
    };
  });
  var files = newFiles.map(function (file) {
    var restrictionError = validateSingleFile(file);
    return {
      type: 'file',
      id: file.requestPath,
      restrictionError: restrictionError,
      status: isParentFolderChecked && !restrictionError ? 'checked' : 'unchecked',
      parentId: scrolledFolder.id,
      data: file
    };
  });
  var newPartialTree = [].concat(_toConsumableArray(partialTreeWithUpdatedScrolledFolder), _toConsumableArray(folders), _toConsumableArray(files));
  return newPartialTree;
};

export default afterScrollFolder;